import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root'
})
export class CustomFieldService {
  httpOptions;
  httpBoday = '';
  tokenData;
  countrieValue;
  buid;
  customFieldId;
  pageIndex = 1
  pageSize = 10;
  constructor(private http: HttpClient) {
  }

  getValueOfPagination(pageIndex, pageSize) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize
  }

  getCustomFieldData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.get<any>(ApiEndPoint.CustomFields.Jobs.fields + `?recordsPerPage=${this.pageSize}&page=${this.pageIndex}`, this.httpOptions);
  }

  addCustomField(customFieldValue): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.post<any>(ApiEndPoint.CustomFields.Jobs.fields, customFieldValue, this.httpOptions);
  }

  updateCustomField(customFieldBody, customFieldID): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.put<any>(ApiEndPoint.CustomFields.Jobs.fields, customFieldBody, this.httpOptions);
  }

  updateCustomFieldJobOrder(customFieldBody): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.put<any>(ApiEndPoint.CustomFields.Jobs.updateOrder, customFieldBody, this.httpOptions);
  }

  updateCustomFieldHireOfferOrder(customFieldBody): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };
    return this.http.put<any>(ApiEndPoint.CustomFields.Hire.updateOrder, customFieldBody, this.httpOptions);
  }

  deleteCustomField(customFieldID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.CustomFields.Jobs.delete, { "customFieldID": customFieldID }, this.httpOptions);
  }
  // <!--              -----------API For Hire/Offer Start Here-----------               -->

  getHire_OfferData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.get<any>(ApiEndPoint.CustomFields.Hire.fields, this.httpOptions);
  }

  addHire_OfferField(hire_offerValue): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };

    return this.http.post<any>(ApiEndPoint.CustomFields.Hire.fields, hire_offerValue, this.httpOptions);
  }

  updateHire_OfferField(hire_offerBody, hire_offerId): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': this.tokenData,
        'language-iso': 'en'
      })
    };
    
    return this.http.put<any>(ApiEndPoint.CustomFields.Hire.fields, hire_offerBody, this.httpOptions);
  }

  deleteHire_OfferField(customFieldID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.CustomFields.Hire.delete, { "customFieldID": customFieldID }, this.httpOptions);
  }
}

